import { useEffect, useState, createContext, useContext } from "react";

const KEY = "jt_theme";
const Ctx = createContext({ theme: "light", toggle: () => {} });

export function ThemeProvider({ children }) {
  // Default: LIGHT (user preference — do not follow system prefers-color-scheme)
  const [theme, setTheme] = useState(() => {
    const stored = localStorage.getItem(KEY);
    return stored === "dark" ? "dark" : "light";
  });

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem(KEY, theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  return <Ctx.Provider value={{ theme, toggle }}>{children}</Ctx.Provider>;
}

export const useTheme = () => useContext(Ctx);
